import { setCookie, getCookie, delCookie } from './cookie';

// formatDate
export function formatDate(date, fmt) {
  date = new Date(date);
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }
  return fmt;
}

export function timestampToTime(timestamp) {
  let date = new Date(timestamp * 1000); // timestamp 10wei *1000，timestamp 13wei not *1000
  let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  let strDate = h + m;
  return strDate;
}

/**
 * is null
 * @param value
 */
export function isUndefined(value) {
  return value === undefined || value === null || value === '';
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

// getUserId
export function getUserId() {
  return getCookie('userId') || '';
}

// save user info
export function setUser(data) {
  setCookie('userId', data.userId);
  setCookie('token', data.token);
}

// clear user info
export function clearUser() {
  delCookie('userId');
  delCookie('token');
  window.localStorage.removeItem('__message__');
  window.localStorage.removeItem('__usermap__');
  sessionStorage.clear();
}

// goLogin
export function goLogin() {
  location.href = location.href.split('://')[0] + '://' + location.host + '/login';
}

// isLogin
export function isLogin() {
  return !!getUserId();
}

/**
 * formatAmount
 * @param money
 * @param format
 * @param coin
 * @param isRe has remove zero
 */
export function formatAmount(money) {
  return money;
}

//getUrlParam
export function getUrlParam(name, loc) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var locat = loc ? '?' + loc.split('?')[1] : '';
  var r = (locat ? locat : window.location.search).substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return '';
}

//cal percent rate
export function getPercentum(n1, n2) {
  if (n1 == '0' && n2 == '0') {
    return '0';
  }
  var n = (n1 / n2) * 100;
  return parseInt(n) + '%';
}

// ISIOS
export const ISIOS = /(iphone|ipod|ipad)/i.test(navigator.userAgent);

// setTitle
export function setTitle(title) {
  if (document.title !== title) {
    document.title = title;
    if (ISIOS) {
      let iframe = document.createElement('iframe');
      iframe.src = '//m.baidu.com/favicon.ico';
      iframe.style.display = 'none';
      iframe.onload = () => {
        setTimeout(() => {
          iframe.remove();
        }, 9);
      };
      document.body.appendChild(iframe);
    }
  }
}

// debounce delay function
export function debounce(func, delay) {
  let timer;
  return function(...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

// clearContentTag
export function clearTag(content) {
  return content.replace(/<[^>]+>|<\/[^>]+>|<[^>]+\/>|&nbsp;/gi, '');
}

// isFunction
export function isFunction(fn) {
  var getType = {};
  return fn && getType.toString.call(fn) === '[object Function]';
}

// get image base64
export function getImgData(fileType, img, dir, next) {
  let image = new Image();
  image.onload = function() {
    let degree = 0;
    let drawWidth;
    let drawHeight;
    let width;
    let height;
    drawWidth = this.naturalWidth;
    drawHeight = this.naturalHeight;
    let canvas = document.createElement('canvas');
    canvas.width = width = drawWidth;
    canvas.height = height = drawHeight;
    let context = canvas.getContext('2d');
    // by image position，resize canvas ，rotate angle，iphone default is home key on right Landscape shot
    switch (dir) {
      // iphone Landscape shot，home key on left
      case 3:
        degree = 180;
        drawWidth = -width;
        drawHeight = -height;
        break;
      // iphone Portrait shot，home key on down
      case 6:
        canvas.width = height;
        canvas.height = width;
        degree = 90;
        drawWidth = width;
        drawHeight = -height;
        break;
      // iphone Portrait shot，home key on up
      case 8:
        canvas.width = height;
        canvas.height = width;
        degree = 270;
        drawWidth = -width;
        drawHeight = height;
        break;
    }
    // use canvas rotate
    context.rotate((degree * Math.PI) / 180);
    context.drawImage(this, 0, 0, drawWidth, drawHeight);
    // return correct image
    next(canvas.toDataURL(fileType, 0.8));
  };
  image.src = img;
}

/**
 * get user login system's time interval
 * @param {yyyy-MM-dd-hh-mm} beforeTime
 */
export function calcSpace(beforeTime) {
  let now = formatDate(new Date().getTime(), 'yyyy-MM-dd-hh-mm').split('-');
  let before = beforeTime.split('-');
  let nowYear = +now[0];
  let beforeYear = +before[0];
  let nowMonth = +now[1];
  let beforeMonth = +before[1];
  if (nowYear > beforeYear) {
    let diffY = nowYear - beforeYear;
    let diffM = diffY * 12 + nowMonth - beforeMonth;
    return diffM < 12 ? diffM + '月前来过' : diffY + '年前来过';
  }
  if (nowMonth > beforeMonth) {
    return nowMonth - beforeMonth + '月前来过';
  }
  let nowDay = now[2];
  let beforeDay = before[2];
  if (nowDay > beforeDay) {
    return nowDay - beforeDay + '天前来过';
  }
  let nowHour = now[3];
  let beforeHour = before[3];
  if (nowHour > beforeHour) {
    return nowHour - beforeHour + '小时前来过';
  }
  let nowMinute = now[4];
  let beforeMinute = before[4];
  let diffMinute = nowMinute - beforeMinute;
  return diffMinute <= 5 ? '刚刚来过' : diffMinute + '分钟前来过';
}

/**
 * get time interval,over one day then formate
 * @param time
 */
export function calcSpaceData(time) {
  let beforeTime = formatDate(time, 'yyyy-MM-dd-hh-mm')
  let now = formatDate(new Date().getTime(), 'yyyy-MM-dd-hh-mm').split('-');
  let before = beforeTime.split('-');
  let nowYear = +now[0];
  let beforeYear = +before[0];
  let nowMonth = +now[1];
  let beforeMonth = +before[1];
  if (nowYear > beforeYear) {
    return formatDate(time, 'yyyy-MM-dd hh:mm');
  }
  if (nowMonth > beforeMonth) {
    return formatDate(time, 'yyyy-MM-dd hh:mm');
  }
  let nowDay = now[2];
  let beforeDay = before[2];
  if (nowDay > beforeDay) {
    return formatDate(time, 'yyyy-MM-dd hh:mm');
  }
  let nowHour = now[3];
  let beforeHour = before[3];
  if (nowHour > beforeHour) {
    return nowHour - beforeHour + '小时前';
  }
  let nowMinute = now[4];
  let beforeMinute = before[4];
  let diffMinute = nowMinute - beforeMinute;
  return diffMinute <= 5 ? '刚刚' : diffMinute + '分钟前';
}

// formatChatDate
export function formatChatDate(timeStamp, param) {
  let now = new Date();
  let nowStamp = now.getTime();
  let before = new Date(timeStamp);
  let week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  let oneDay = 3600000 * 24;
  let sevenDay = 7 * oneDay;
  let twoDay = 2 * oneDay;
  if (nowStamp - timeStamp > sevenDay) {
    return param ? formatDate(timeStamp, 'yyyy年MM月dd日 hh:mm') : formatDate(timeStamp, 'yyyy/MM/dd');
  }
  if (nowStamp - timeStamp > twoDay) {
    return param ? week[before.getDay()] + ' ' + formatDate(timeStamp, 'hh:mm') : week[before.getDay()];
  }
  if (now.getDate() === before.getDate()) {
    return formatDate(timeStamp, 'hh:mm');
  }
  let _before = new Date(timeStamp);
  _before.setDate(_before.getDate() + 1);
  if (_before.getDate() === now.getDate()) {
    return param ? '昨天 ' + formatDate(timeStamp, 'hh:mm') : '昨天';
  }
  return param ? week[before.getDay()] + ' ' + formatDate(timeStamp, 'hh:mm') : week[before.getDay()];
}

//calculateDays
export function calculateDays(start, end) {
  if (!start || !end) return 0;
  start = new Date(start);
  end = new Date(end);
  return (end - start) / (60 * 1000);
}

export function setWebIcon(link) {
  let $favicon = document.querySelector('link[rel="shortcut icon"]');
  if ($favicon !== null) {
    $favicon.rel = 'icon';
    $favicon.type = 'image/x-icon';
    $favicon.href = link;
  } else {
    $favicon = document.createElement('link');
    $favicon.rel = 'shortcut icon';
    $favicon.type = 'image/x-icon';
    $favicon.href = link;
    document.head.appendChild($favicon);
  }
}
